import { assign, includes } from 'lodash'
import parser from 'ua-parser-js'

import { Flow } from 'constants/flowConstants'
import { SEGMENT_TRACKING_BLACKLIST } from 'constants/trackingConstants'
import * as OrgSelectors from 'modules/org/selectors'
import store from 'modules/store'
import * as UserSelectors from 'modules/user/selectors'

export const track = (eventName, properties) => {
  const state = store.getState()
  const email = UserSelectors.getEmail(state)
  const orgId = OrgSelectors.getOrgId(state)

  if (!window.analytics || includes(SEGMENT_TRACKING_BLACKLIST, orgId)) {
    return
  }
  const propertiesWithEmail = assign({}, { email, orgId }, properties)
  window.analytics.track(eventName, propertiesWithEmail)
}

export const identifyUser = (
  traits = {},
  orgId = undefined,
  userId = undefined
) => {
  const state = store.getState()
  const email = UserSelectors.getEmail(state)
  const finalUserId = userId || UserSelectors.getUserId(state)
  const finalOrgId = orgId || OrgSelectors.getOrgId(state)
  const name = UserSelectors.getName(state)
  const userJwt = UserSelectors.getUserJwt(state)

  if (!finalUserId) {
    return
  }

  if (userJwt && window.drift && window.drift.setUserJwt) {
    window.drift.setUserJwt(userJwt)
  }

  return (
    window.analytics &&
    window.analytics.identify(
      `${finalOrgId}-${finalUserId}`,
      {
        name,
        email,
        orgId: finalOrgId,
        ...traits,
      },
      { integrations: { drift: { userJwt } } }
    )
  )
}

export const page = (pageName, properties = {}) => {
  const state = store.getState()
  const orgId = OrgSelectors.getOrgId(state)

  if (!window.analytics || includes(SEGMENT_TRACKING_BLACKLIST, orgId)) {
    return
  }
  window.analytics.page(pageName, properties)
}

export const hasCompletedVideoOnboarding = !!localStorage.getItem(
  'video_signup_completed'
)

export const getVideoSignupReferrer = () =>
  localStorage.getItem('signup_referrer')
export const getVideoWebstoreSignupReferrer = () =>
  localStorage.getItem('drift_video_webstore_referrer')

export const setVideoSignupReferrer = ({
  source,
  location,
  isWebstoreReferral = false,
}) => {
  const videoReferralSource = getVideoSignupReferrer()
  const videoWebstoreReferralSource = getVideoWebstoreSignupReferrer()

  // Did we receive an empty source?
  if (!source) {
    track('Signup Referral Source Missing', {
      hasCompletedVideoOnboarding,
      location,
    })
  }

  // Are we trying to 'cache' a webstore referral value?
  if (isWebstoreReferral) {
    window.localStorage.setItem('drift_video_webstore_referrer', source)
  } else if (videoWebstoreReferralSource) {
    // Should we be using a 'cached' webstore referral value instead?
    window.localStorage.setItem('signup_referrer', videoWebstoreReferralSource)
    window.localStorage.removeItem('drift_video_webstore_referrer')
    track('Signup Referral Source Updated', {
      from: videoReferralSource,
      to: videoWebstoreReferralSource,
      isWebstoreReferral: true,
      hasCompletedVideoOnboarding,
      location,
    })
  } else {
    // Are we updating an existing value?
    if (videoReferralSource) {
      track('Signup Referral Source Updated', {
        from: videoReferralSource,
        to: source,
        hasCompletedVideoOnboarding,
        location,
      })
    }

    // Now we can safely store the referral source
    window.localStorage.setItem('signup_referrer', source)
  }
}

// WARNING: DO NOT CHANGE WITHOUT CONSULTING OPS AND/OR #analytics
export const sendProductEnabled = ({ flow, triggeredBy }) => {
  const ua = parser()

  let trackingOptions = {
    product: flow,
    browser: ua.browser.name,
    os: ua.os.name,
  }

  if (flow === Flow.VIDEO) {
    trackingOptions = {
      route: getVideoWebstoreSignupReferrer() || getVideoSignupReferrer(),
      triggeredBy,
      hasCompletedVideoOnboarding,
      ...trackingOptions,
    }
  }

  track('Product Enabled', trackingOptions)
}

// WARNING: DO NOT CHANGE WITHOUT CONSULTING OPS AND/OR #analytics
export const bizibleTrackNewPQL = ({ email }) => {
  // Preamble for all API usage.
  window['Bizible'] = window['Bizible'] || {
    _queue: [],
    Push: function (o, p) {
      this._queue.push({ type: o, data: p })
    },
  }

  // let Bizible post this async
  window['Bizible'].Push('User', {
    eMail: email,
  })
}
